const adChoices = { url: '/ads' };
const magnify = { url: '/zoom/:imgType/:index' };
const matrixConflict = { url: '/conflict/:type/:itemId' };
const optionDetails = { url: '/option/:itemId' };

const compare = {
  reloadOnSearch: false,
  url:
    '/compare?section&styleOne&styleTwo&styleThree' +
    '&engineOne&bodyTypeOne&driveTypeOne&engineTwo&bodyTypeTwo&driveTypeTwo' +
    '&engineThree&bodyTypeThree&driveTypeThree',
  params: {
    section: {
      array: true,
      value: []
    }
  }
};
const compareTrims = { url: '/trims' };
const compareTable = { url: '/table' };
const compareSelect = { url: '/select/:index' };
const compareCapabilities = { url: '/capabilities' };

const routes = {
  main: {
    url: '/?rpo&ss&styleId&returnUrl',
    reloadOnSearch: false,
    views: {
      '@': {
        component: 'main'
      }
    }
  },
  CONFIG: {
    url: 'config',
    parent: 'main',
    reloadOnSearch: false
  },
  'CONFIG.adChoices': adChoices,
  'CONFIG.compare': compare,
  'CONFIG.compare.trims': compareTrims,
  'CONFIG.compare.trims.table': compareTable,
  'CONFIG.compare.trims.select': compareSelect,
  'CONFIG.compare.capabilities': compareCapabilities,
  'CONFIG.compare.capabilities.table': compareTable,
  'CONFIG.compare.capabilities.select': compareSelect,
  'CONFIG.dimensions': { url: '/dimensions/:dimensionsBodyTypeId' },
  'CONFIG.conflict': matrixConflict,
  'CONFIG.details': optionDetails,
  TRIM: {
    parent: 'main',
    url: 'trim'
  },
  'TRIM.adChoices': adChoices,
  'TRIM.compare': compare,
  'TRIM.compare.trims': compareTrims,
  'TRIM.compare.trims.table': compareTable,
  'TRIM.compare.trims.select': compareSelect,
  'TRIM.compare.capabilities': compareCapabilities,
  'TRIM.compare.capabilities.table': compareTable,
  'TRIM.compare.capabilities.select': compareSelect,
  'TRIM.engine': { url: '/engine/:trimName/:engine/:transmission' },
  'TRIM.features': {
    url: '/features/:sid',
    reloadOnSearch: false
  },
  'TRIM.conflict': matrixConflict,
  'TRIM.details': optionDetails,
  'TRIM.magnify': magnify,
  COLOR: {
    parent: 'main',
    url: 'color'
  },
  'COLOR.adChoices': adChoices,
  'COLOR.magnify': magnify,
  'COLOR.details': optionDetails,
  PACKAGES: {
    url: 'packages',
    parent: 'main'
  },
  'PACKAGES.packageDetails': {
    url: '/package/:pkgId',
    reloadOnSearch: false
  },
  'PACKAGES.packageDetails.item': { url: '/item/:itemId' },
  'PACKAGES.adChoices': adChoices,
  'PACKAGES.magnify': magnify,
  EXTERIOR: {
    parent: 'main',
    url: 'exterior'
  },
  'EXTERIOR.adChoices': adChoices,
  'EXTERIOR.magnify': magnify,
  'EXTERIOR.details': optionDetails,
  INTERIOR: {
    parent: 'main',
    url: 'interior'
  },
  'INTERIOR.adChoices': adChoices,
  'INTERIOR.magnify': magnify,
  'INTERIOR.details': optionDetails,
  ACCESSORIES: {
    url: 'accessories',
    parent: 'main'
  },
  'ACCESSORIES.adChoices': adChoices,
  'ACCESSORIES.magnify': magnify,
  'ACCESSORIES.details': optionDetails,
  SUMMARY: {
    url: 'summary',
    parent: 'main'
  },
  'SUMMARY.magnify': magnify,
  'SUMMARY.paymentEstimate': { url: '/payment?initialTab' },
  'SUMMARY.saveSend': { url: '/share' },
  'SUMMARY.adChoices': adChoices,
  features: {
    reloadOnSearch: false,
    url:
      '/features?returnUrl&section&styleOne&styleTwo&styleThree' +
      '&engineOne&bodyTypeOne&driveTypeOne&engineTwo&bodyTypeTwo&driveTypeTwo' +
      '&engineThree&bodyTypeThree&driveTypeThree',
    params: {
      section: { array: true, value: [] }
    },
    views: {
      '@': {
        component: 'features'
      }
    }
  },
  'features.trims': compareTrims,
  'features.trims.table': compareTable,
  'features.trims.select': compareSelect,
  'features.capabilities': compareCapabilities,
  'features.capabilities.table': compareTable,
  'features.capabilities.select': compareSelect
};

export default routes;
